import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconHelp = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M7.852 13.953a.961.961 0 11-.001 1.923.961.961 0 010-1.923zM8 0a8 8 0 013.001 15.418v-2.221a6 6 0 10-6 0l-.001 2.221A8.003 8.003 0 018 0zm-.011 3.531a4.097 4.097 0 012.968 1.266 3.63 3.63 0 011.022 2.72c-.055 1.028-.056 2.216-1.838 3.368-.531.344-1.316.69-1.316 1.264 0 .415-.37.879-.775.879-.027 0-.053-.002-.08-.005-.44-.042-.716-.432-.716-.874 0-1.125.823-1.649 1.795-2.31 1.337-.91 1.338-1.701 1.334-2.208v-.136l.001-.063A2.057 2.057 0 009.8 5.898a2.491 2.491 0 00-1.802-.768 2.39 2.39 0 00-2.384 2.387.798.798 0 11-1.597 0c0-1.064.412-2.063 1.162-2.816a3.953 3.953 0 012.81-1.17z"
          id="help_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="help_svg__b" fill="#fff">
          <use xlinkHref="#help_svg__a" />
        </mask>
        <use fill="#FFF" xlinkHref="#help_svg__a" />
        <path fill={color} mask="url(#help_svg__b)" d="M-5-4h25v25H-5z" />
      </g>
    </>
  ),
})``;

export default IconHelp;
